import React from 'react';
import ComingSoon from './ComingSoon';

const Taxi = () => {
  return <ComingSoon title="Taxi Services" />;
};

export default Taxi;














